export default class StationsServedJwtService {
  axiosIns = null

  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  create(payload = {}) {
    return this.axiosIns.post(`${this.jwtConfig.main.stationsServedEndpoint}`, payload)
  }

  update(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.stationsServedEndpoint}/${id}`, payload)
  }

  list(params) {
    return this.axiosIns.get(this.jwtConfig.main.stationsServedEndpoint, {
      params
    })
  }

  delete(id) {
    return this.axiosIns.delete(`${this.jwtConfig.main.stationsServedEndpoint}/${id}`)
  }

  get(id) {
    return this.axiosIns.get(`${this.jwtConfig.main.stationsServedEndpoint}/${id}`)
  }
}
